export default __webpack_public_path__ + "static/media/ret-res7.487bbd49.jpg";